import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Book, School, ArrowBack, CloudUpload } from '@mui/icons-material';

const CourseEditorSidebar = ({ activeTab, setActiveTab, courseInfo, lessons, onBackClick }) => {
    return (
        <Box sx={{
            width: 280,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            height: '80vh',
            borderRadius: '10px',
            margin: '0 0 20px 20px',
            position: 'sticky',
            fontFamily: "'Satoshi', sans-serif",
        }}>
            <Box sx={{ padding: '15px 20px', borderBottom: '1px solid #e9ecef' }}>
                <Button
                    onClick={onBackClick}
                    startIcon={<ArrowBack />}
                    sx={{
                        color: '#332872',
                        fontFamily: "'Satoshi', sans-serif",
                        fontWeight: 'bold',
                        textTransform: 'none',
                    }}
                >
                    Back to Courses
                </Button>
            </Box>

            {courseInfo && (
                <Box sx={{ padding: '15px 20px', borderBottom: '1px solid #e9ecef' }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 'bold',
                        color: '#2c3e50',
                        fontFamily: "'Satoshi', sans-serif",
                    }}>
                        {courseInfo.title}
                    </Typography>
                </Box>
            )}

            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 20px',
                        cursor: 'pointer',
                        color: activeTab === 'course-info' ? 'white' : 'black',
                        transition: 'background-color 0.2s',
                        backgroundColor: activeTab === 'course-info' ? '#372e5eff' : 'transparent',
                        '&:hover': { backgroundColor: '#282241ff', color: 'white' },
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px',
                        fontFamily: "'Satoshi', sans-serif",
                    }}
                    onClick={() => setActiveTab('course-info')}
                >
                    <Book sx={{ marginRight: '15px', fontSize: '18px' }} />
                    <span style={{ fontFamily: "'Satoshi', sans-serif" }}>Course Information</span>
                </Box>

                {lessons && lessons.length > 0 ? (
                    lessons.map((lesson) => (
                        <Box
                            key={lesson.id}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '12px 20px 12px 35px',
                                cursor: 'pointer',
                                color: activeTab === `lesson-${lesson.id}` ? 'white' : 'black',
                                transition: 'background-color 0.2s',
                                backgroundColor: activeTab === `lesson-${lesson.id}` ? '#372e5eff' : 'transparent',
                                '&:hover': { backgroundColor: '#282241ff', color: 'white' },
                                fontFamily: "'Satoshi', sans-serif",
                            }}
                            onClick={() => setActiveTab(`lesson-${lesson.id}`)}
                        >
                            <School sx={{ marginRight: '15px', fontSize: '16px' }} />
                            <span style={{ fontFamily: "'Satoshi', sans-serif" }}>
                                {lesson.title || `Lesson ${lesson.order}`}
                            </span>
                        </Box>
                    ))
                ) : (
                    <Box sx={{ padding: '12px 20px 12px 35px', color: '#7f8c8d', fontStyle: 'italic' }}>
                        No lessons available
                    </Box>
                )}
            </Box>

            {/* Media Upload Tab - Added at the end of the sidebar */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '12px 20px',
                    cursor: 'pointer',
                    color: activeTab === 'media-upload' ? 'white' : 'black',
                    transition: 'background-color 0.2s',
                    backgroundColor: '#372e5eff',
                    '&:hover': { backgroundColor: '#282241ff', color: 'white' },
                    borderBottomLeftRadius: '6px',
                    borderBottomRightRadius: '6px',
                    fontFamily: "'Satoshi', sans-serif",
                    marginTop: 'auto', // This pushes it to the bottom
                }}
                onClick={() => setActiveTab('media-upload')}
            >
                <CloudUpload sx={{ marginRight: '15px', fontSize: '18px', color:'#ffffff' }} />
                <span style={{ fontFamily: "'Satoshi', sans-serif",color:'#ffffff' }}>Media Upload</span>
            </Box>
        </Box>
    );
};

export default CourseEditorSidebar;